<template>
  <div>
    <toggle-single
      id="enable-agenda"
      label-name="Enabled"
      :toggle-model="hasChat"
      @toggle-click="handleToggleClick"
    />

    <toggles-form :data-array="toggles" @toggles-change="handleToggleChange" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import TogglesForm from "@/components/forms/togglesForm";
import ToggleSingle from "@/components/common/toggleSingle";
export default {
  name: "AddEditSession_Chat",
  components: {
    ToggleSingle,
    TogglesForm
  },
  props: {
    form: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  beforeMount() {},
  mounted() {},
  computed: {
    ...mapGetters({})
  },
  methods: {
    handleToggleChange(event) {
      //Maybe make top level
      /* let checkedId = event.target.id ? event.target.id : null;
      if (checkedId) {
        this.settingsUser[checkedId] = event.target.checked
            ? event.target.checked
            : false;
      }
      this.handleSettingsUserChange(this.settingsUser);*/
    },
    handleValueChange(key, value) {
      //mixin
      this.$emit("value-change", { key: key, value: value });
    },
    handleToggleClick() {
      this.hasChat = !this.hasChat;
      this.handleValueChange("hasChat", this.hasChat);
    },
    input(val) {
      this.handleValueChange("agenda", val.content);
    },
    resetClear() {
      this.clear = false;
    }
  },
  data() {
    return {
      production: true,
      clear: false,
      hasChat: this.form && this.form.hasChat ? this.form.hasChat : true,
      toggles: [
        {
          name: "sound",
          description: "",
          property: "_sound",
          type: "btns",
          text: "Sound",
          isAvail: true,
          value: true
        },
        {
          name: "chatter Image",
          description: "",
          property: "_chatterImage",
          type: "btns",
          text: "User Image",
          isAvail: true,
          value: true
        },
        {
          name: "emoticons",
          description: "",
          property: "_logCallType",
          type: "btns",
          text: "Emoticons",
          isAvail: true,
          value: false
        },
        {
          name: "copy",
          description: "",
          property: "_logCallOutcome",
          type: "btns",
          text: "Allow Copy",
          isAvail: true,
          value: false
        },
        {
          name: "block",
          description: "",
          property: "_logCallOutcome",
          type: "btns",
          text: "Block Words",
          isAvail: true,
          value: false
        },
        {
          name: "callType",
          description: "",
          property: "_logCallType",
          type: "btns",
          text: "Word Limit",
          isAvail: true,
          value: false
        },
        {
          name: "anonymous",
          description: "",
          property: "_logCallOutcome",
          type: "btns",
          text: "Annonymous",
          isAvail: true,
          value: false
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.birthday_input {
  position: relative;
}
.session-calendar-wrapper {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1;
}
#session_calender .btn-outline-info:hover,
#session_calender .btn-outline-info:active,
#session_calender .btn-outline-info:focus {
  background-color: var(--theme-color);
  background: var(--theme-color);
}
</style>
